import { configuration, proposal, funnel } from '@/services/axios'

/**
 * Função responsável por fazer uma requisição de forma mais simples nas configurações do painel.
 * @param {String} config Recebe uma chave referente a configuração requisitada, Ex: *nameBusiness*, *brandLogo*.
 * @param {String} type Espera que seja informado o tipo de dado, ***value*** ou *value_long*. Por padrão: ***value***.
 * @returns {Object | Null} Retorna o resultado da requisição de configurações ou **null** no caso de erro.
 */
export async function getConfig(config, type = 'value') {
	try {
		const request = (await configuration.getConfig(config)).data
		return request[type]
	} catch (error) {
		return null
	}
}

export async function saveConfig(config, data, type = 'value') {
	try {
		return await configuration.updateConfig(config, {
			[type]: data,
		})
	} catch (error) {
		return null
	}
}

export async function updateImage(config, data) {
	try {
		return await configuration.updateConfig(config, data)
	} catch (error) {
		return null
	}
}

export async function getProposalGroup() {
	try {
		return (await proposal.getProposalGroup()).data
	} catch (error) {
		return []
	}
}

export async function getProposalSettings() {
	try {
		return await proposal.getProposalSettings()
	} catch (error) {
		return []
	}
}

export async function getStages() {
	try {
		return (await funnel.getStages()).data
	} catch (error) {
		return []
	}
}

export async function getMonetaryFields() {
	try {
		return (await funnel.getMonetaryFields()).data
	} catch (error) {
		return []
	}
}
